export default {
  // titles
  attachmentsHeader: 'Attachments',
  deadlineHeader: 'Deadline',
  deliveryStatusHeader: 'Delivery Status',
  idHeader: 'Id',
  itemListHeader: 'Order Item List',
  mapsHeader: 'Maps',
  mapStatusHeader: 'Map Status',
  orderHeader: 'Order',
  orderStatusHeader: 'Order Status',
  projectHeader: 'Project',
  stateHeader: 'State',
  statusHeader: 'Status',
  titleHeader: 'Title',
  // labels
  deadlineLabel: 'Deadline',
  itemDescriptionLabel: 'Description*',
  itemTitleLabel: 'Item Title*',
  titleLabel: 'Order Title*',
  priorityLabel: 'Priority',
  projectLabel: 'Project',
  // buttons
  addAttachmentButton: 'Add Attachment',
  addItemButton: 'Add Item',
  saveItemButton: 'Save Item',
  submitButton: 'Submit Order',
  // select options
  priorityHighOption: 'High',
  priorityLowOption: 'Low',
  priorityNormalOption: 'Normal',
  priorityUrgentOption: 'Urgent',
  // text
  confirmDeleteOrderText: 'Are you sure you want to discard this order? All items will be removed and information already entered will be deleted.',
  needsApprovalTooltip: 'New Approval Required',
  previewLink: 'Preview'
};



// WEBPACK FOOTER //
// ./public/js/resources/en/axis.js